import React from "react";
import styled from "styled-components";
import { Overlay, Navbar } from "components/common/candidate";
import { ChooseDate, Info } from "./components";

export default ({ isAuthenticated, selectedSlot, setSelectedSlot }) => (
  <Overlay>
    <Navbar step={2} title="Schedule Your Call" />
    <Body>
      <ChooseDate onSlotChange={setSelectedSlot} />
      <Info selectedSlot={selectedSlot} isAuthenticated={isAuthenticated} />
    </Body>
  </Overlay>
);

const Body = styled.div`
  width: calc(100% - 20px);
  margin: 0 auto;
  background-color: #f9f7f2;
  @media (max-width: 680px) {
    width: 100%;
    background-color: #f9f7f2;
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/View.js